var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.epsonLayout
    ? _c("app-epson-label-modal", {
        attrs: {
          layout: _vm.epsonLayout,
          records: _vm.epsonRecords,
          copies: _vm.copies,
        },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      })
    : _c(
        "w-modal",
        {
          attrs: { "escape-close": "", value: "" },
          on: {
            input: function ($event) {
              return _vm.close()
            },
          },
        },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c(
                "w-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.$ct("print-labels")) + " "),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                ],
                1
              ),
              _vm.isElectron
                ? _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input-number", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.$ct("common.copies"),
                                  decimals: 0,
                                  min: 1,
                                },
                                model: {
                                  value: _vm.copies,
                                  callback: function ($$v) {
                                    _vm.copies = $$v
                                  },
                                  expression: "copies",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-list",
                _vm._l(_vm.layouts, function (layout) {
                  return _c(
                    "w-list-item",
                    {
                      key: layout.ID,
                      attrs: { disabled: _vm.isPrinting },
                      on: {
                        click: function ($event) {
                          return _vm.printWithLayout(layout)
                        },
                      },
                    },
                    [_c("w-list-item-text", [_vm._v(_vm._s(layout.Name))])],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }